module.exports = __webpack_public_path__ + "img/person-stand-xyr.54d62005.png";